var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1481 16.6746C33.1481 7.46496 25.7285 0 16.5741 0C7.41966 0 0 7.46496 0 16.6746C0 24.9992 6.05948 31.8974 13.9841 33.1481V21.4955H9.77649V16.6735H13.9841V13.0007C13.9841 8.82183 16.4581 6.51251 20.2447 6.51251C22.0568 6.51251 23.9551 6.83846 23.9551 6.83846V10.9422H21.8634C19.8049 10.9422 19.164 12.2284 19.164 13.5476V16.6746H23.7606L23.0258 21.4944H19.164V33.1481C27.0887 31.8974 33.1481 24.9992 33.1481 16.6746Z",
    fill: "#002561"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/FacebookLogo.1adb89e159a295adf43bd944fc93779c.svg";
export { ForwardRef as ReactComponent };